import { PARAMETRES_AFFIXE2 } from '@/configuration/paramsAffixe2';
import * as allTypes from '../mutation-type';
import * as types from './user-mutation-type';
import { getUser, login, refresh, getUsers } from '../../api/login/index';
import { resetState } from '../store';

function initialState() {
  return {
    security: { isLogged: false },
    site: '',
    afficherAzimut: true,
    agenceId: null,
    isUserAffixe2: true,
    users: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.LOG_IN](state, user) {
    state.security = { isLogged: true, ...user };
  },
  [types.SET_USER](state, user) {
    state.user = user;
    state.agenceId = user.agenceId;
    if (state.user.agencesId && state.user.agencesId.length > 1) {
      state.agenceId = null;
    }
  },
  [types.SET_AGENCE_ID](state, agenceId) {
    state.agenceId = agenceId;
  },
  [types.LOG_OUT](state) {
    state.security = { isLogged: false };
    state.user = {};
    resetState();
  },
  [types.SET_SITE](state, site) {
    state.site = site;
  },
  [types.SET_AZIMUT](state, afficherAzimut) {
    state.afficherAzimut = afficherAzimut;
  },
  [types.SET_IS_USER_AFFIXE2](state, isUserAffixe2) {
    state.isUserAffixe2 = isUserAffixe2;
  },
  [types.SET_USERS](state, users) {
    state.users = users;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  logIn: async ({ getters, commit, dispatch }, payload) => {
    const responseLogin = await login(payload.site, payload.email, payload.password);
    if (payload.site !== getters.site || payload.email !== getters.userEmail) {
      resetState();
      commit(types.SET_SITE, payload.site);
    }
    commit(types.LOG_IN, responseLogin.data);
    const responseUser = await getUser(payload.email);
    commit(types.SET_USER, responseUser.data);
    await dispatch('parametrage/rechercheParametrages', {}, { root: true });
    await dispatch('parametrage/loadParamAffixe2', PARAMETRES_AFFIXE2.autoriserAuthentificationAffixe1.key, { root: true });
    await dispatch('venteFacesLc/getPanneauxNoGeoNoAttach', {}, { root: true });
  },
  refresh: ({ commit }) => {
    return new Promise((resolve, reject) => {
      refresh().then((response) => {
        commit(types.LOG_IN, response.data);
        resolve();
      }).catch(err => {
        commit(types.LOG_OUT);
        reject(err.code);
      });
    });
  },
  logOut: ({ commit }) => {
    return new Promise((resolve) => {
      commit(types.LOG_OUT);
      resolve();
    });
  },
  setAzimut: (commit, state, newValue) => {
    commit('SET_AZIMUT', newValue);
    return state.afficherAzimut;
  },
  loadUsers: async ({ commit }) => {
    const res = (await getUsers(this.searchUser)).data;
    const users = res
      .filter(el => (el.email || el.identifiant || el.id) && el.actif);
    commit(types.SET_USERS, users);
  },
};

const getters = {
  accessToken: state => {
    return state.security.access_token;
  },
  refreshToken: state => {
    return state.security.refresh_token;
  },
  isLogged: state => {
    return state.security.isLogged;
  },
  hasGeoMarketing: state => {
    if (state.user === undefined) return false;
    return !!state.user.accesGeoMarketing;
  },
  hasPortailAnnonceur: state => {
    if (state.user === undefined) return false;
    return !!state.user.accesPortailAnnonceur;
  },
  userEmail: state => {
    if (state.user === undefined) return '';
    return state.user.email;
  },
  userId: state => {
    if (state.user === undefined) return '';
    return state.user.id;
  },
  identifiantUser: state => {
    if (state.user === undefined) return '';
    return state.user.email || state.user.identifiant || state.user.id;
  },
  userCode: state => {
    if (state.user === undefined) return '';
    return state.user.code;
  },
  site: state => {
    return state.site;
  },
  isUserAffixe2: state => {
    return state.isUserAffixe2;
  },
  afficherAzimut: state => {
    return state.afficherAzimut;
  },
  idSociete: state => {
    if (state.user === undefined) return '';
    return state.user.socCode;
  },
  agenceId: state => state.agenceId,
  agenceIdUser: state => {
    if (state.user === undefined) return '';
    return state.user.agenceId;
  },
  agences: state => {
    if (state.user === undefined) return [];
    return state.user.agences;
  },
  isSupport: state => {
    if (!state.user) return false;
    return state.user.email === 'support@quadra-diffusion.fr' || state.user.identifiant === 'quadraadmin';
  },
  isAffichageFaceEditionDefault: state => {
    if (state.user === undefined) return false;
    return !!state.user.affichageFaceEditionDefault;
  },
  getCleApiGoogle: state => {
    return state.user ? state.user.cleApiGoogle : '';
  },
  user: state => {
    return state.user;
  },
  users: state => {
    return state.users;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js